import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import React from "react";
import {ThemeProvider} from "styled-components";
import {RouterOutletBox} from "./boxes/router-outlet.box";

@observer
export class RouterOutletComponent extends OrbitComponent<{}> {
  render() {
      if(this.services.miniOrbit.isEnabled) { // Bug 1865301: CGP - CIP8 - iOS - The page cannot be scrolled vertically (Merged PR 34037: Improve CLS)
          return this.services.routing.currentRoute?.render() || null;
      }

      return (
          <ThemeProvider theme={this.services.theme.mainContentTheme}>
              <RouterOutletBox minHeight={this.services.window.innerHeight + 'px'}>
                  {this.services.routing.currentRoute?.render() || null}
              </RouterOutletBox>

          </ThemeProvider>
      )

  }
}
